import client from '../client'

export const getBasicDetailsKey = `${process.env.NEXT_PUBLIC_ACCOUNT_DOMAIN}/api/Accounts/GetBasicDetails`

export async function getBasicDetails() {
  return client(getBasicDetailsKey)
}
